import * as apiPostProduct from 'api/erp/PostProduct';
import * as apiPost from 'api/orderGuide/PostErpOrderGuideV1';
import { Functor } from 'functions/Functor';
import { Optional } from 'functions/promiseExtensions';
import * as DirectionList from 'types/Recipe/Detail/ErpNew/DirectionList';
import * as ProductList from 'types/Recipe/Detail/ErpNew/ProductList';

export * as OrderGuide from 'types/Recipe/Detail/ErpNew/OrderGuide';

export type Type = {
	[ingredientId: string]: DirectionList.Type;
};

export function create(): Type {
	return {};
}

export async function postToApi(ingredientIds: string[]): Promise<apiPost.ResponseData> {
	const response = await apiPost.callApi(ingredientIds);
	return response.getOrDefault([]);
}

function mapFromApiPost(input: apiPost.ResponseData): Type {
	const output: Type = create();
	input.forEach((e) => {
		if (output[e.ingredientId]) {
			output[e.ingredientId].push(...DirectionList.mapFromApiPost(e.products));
		} else {
			output[e.ingredientId] = DirectionList.mapFromApiPost(e.products);
		}
	});
	return output;
}

export async function getOrderGuideByIngredientIds(ingredientIds: string[]): Promise<Type> {
	return Functor.From(ingredientIds).mapAsync(postToApi).map(mapFromApiPost).get();
}

export function getAllProductIdsFromIngredientId(orderGuide: Type, ingredientId: string): string[] {
	return Optional.Maybe(orderGuide[ingredientId])
		.map(DirectionList.getAllProductIds)
		.getOrDefault([]);
}

export async function getAllProductFromIngredientId(
	ingredientId: string
): Promise<ProductList.Type> {
	const orderGuide = await Functor.From(ingredientId)
		.mapAsync((e) => getOrderGuideByIngredientIds([e]))
		.get();
	return await Functor.From(orderGuide)
		.map((e) => mapToApi(e, ingredientId))
		.mapAsync(ProductList.getFromApi)
		.map((e) => ProductList.applyIngredientIdToProducts(e, ingredientId))
		.map((e) => ProductList.applyOrderGuidePriority(e, orderGuide))
		.map(ProductList.sortByPriority)
		.get();
}

export function mapToApi(orderGuide: Type, ingredientId: string): apiPostProduct.Request[] {
	const data: { productId: string; sourceId: string }[] = orderGuide[ingredientId] ?? [];
	return ProductList.mapToApi(data);
}
